import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { DiscoveryApp } from './App';
import { discoveryApi } from './api/discovery';
import './styles.css';
import './discovery-shell.css';

window.discoveryApi = discoveryApi;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <DiscoveryApp />
    </BrowserRouter>
  </StrictMode>
);